import { composeFieldPath } from '@northfork/basics'
import { CounterParty } from '../../counter-party.model'
import { TransactionTypeKey } from '../../transaction-type.model'
import { Transaction } from '../transaction'

export interface FXSpot extends Transaction {
  clearedDate?: string //isofull
  counterPartyId: number
  fromSecurityId?: number
  fromUnits?: number
  postDate: string //isodate
  securityId?: number
  sellToBuyRate?: number
  counterParty?: CounterParty
  toSecurityId?: number
  toUnits?: number
  units?: number
  commission?: number
  factor?: number
}

export type FXSpotType = {
  label: string
  type: 'FXS' | 'FXF'
  tranType: TransactionTypeKey
}
export const fxField = composeFieldPath([] as FXMappingModel[])
export interface FXMappingModel {
  id: keyof FXForwardMappingRow | keyof FXSpotMappingRow
  validityStatus: 'valid' | 'invalid' | 'warning'
  isEditable: boolean
  type: 'string' | 'number' | 'date'
  field: string
  value: string
  errorMessage?: string
}

export interface FXForwardMappingRow {
  account: string
  entryDate: string
  settleDate: string
  fromSecurityId: string
  toSecurityId: string
  fromUnits: string
  toUnits: string
  counterParty: string
}

export interface FXSpotMappingRow {
  account: string
  entryDate: string
  settleDate: string
  tranType: string
  fromSecurityId: string
  toSecurityId: string
  fromUnits: string
  sellToBuyUnitRatio: string
  toUnits: string
  buyToSellUnitRatio: string
  counterParty: string
}
